import {IAlertViewModalController, MK_ALERT_VIEW_MODAL_MODEL} from "./IAlertViewModalController";
import {inject, Injectable, signal} from "@angular/core";
import {AbstractModalController} from "../../../controllers/AbstractModalController";
import {AlertCommentRepository} from "../../../repositories/alert-comment.repository";
import {UserSessionRepository} from "../../../repositories/user-session.repository";
import {MK_MODAL_FOOTER_CONFIG, MK_MODAL_HEADER_CONFIG} from "../../../controllers/IModalController";
import {AlertData} from "../../../interfaces/domain/alert/AlertData";
import {AlertStatus} from "../../../interfaces/domain/alert/AlertStatus";
import {ControllerEventBus} from "../../../event-buses/controller.event-bus";
import {ControllerEvent} from "../../../event-buses/ControllerEvent";
import {AlertControllerEventName} from "../_event-bus/AlertControllerEventName";

@Injectable()
export class AlertViewModalController  extends AbstractModalController  implements IAlertViewModalController {

  private readonly alertCommentRepository: AlertCommentRepository;
  private readonly userSessionRepository: UserSessionRepository;
  readonly currentUserId: number = 0;

  constructor(controllerEventBus: ControllerEventBus) {
    super(controllerEventBus);

    this.userSessionRepository = inject(UserSessionRepository);
    this.alertCommentRepository = inject(AlertCommentRepository);
    this.currentUserId = this.userSessionRepository.getUserSession()?.userId!;

    this.addModel(MK_MODAL_FOOTER_CONFIG, {
      actions$: signal([
        {
          label: 't.commonCancelBtn',
          name: 'ActionCancel',
          disabled: false,
          classNames: ['lcs-footer-action-cancel'],
        },
        {
          label: 't.alertViewBtn2',
          name: 'ActionAcknowledge',
          disabled: false,
          hidden: true,
        }
      ]),
    });

    this.addModel(MK_MODAL_HEADER_CONFIG, {
      title$: signal(''),
      titleIconPath$: signal(null),
    });

    this.addModel(MK_ALERT_VIEW_MODAL_MODEL, {
      alertData$: signal(null)
    });
  }


  protected handleActionCancel(eventData: any): void {
    this.closeModal();
  }


  override handleInit(eventData: any) {
    super.handleInit(eventData);
    let model = this.getModel(MK_ALERT_VIEW_MODAL_MODEL);
    let alertData: AlertData = eventData['alert'];
    if(alertData.status === AlertStatus.OPEN) {
      this.showFooterAction('ActionAcknowledge');
    } else {
      this.hideFooterAction('ActionAcknowledge');
    }
    this.getModel(MK_ALERT_VIEW_MODAL_MODEL).alertData$.set(alertData);
  }

  handleActionAcknowledge() {
    let model = this.getModel(MK_ALERT_VIEW_MODAL_MODEL);
    let alertData = model.alertData$()!;
    let bodyData = {
      username: this.currentUserId,
      alertInstanceId: Number(alertData.alertInstanceId),
      alertRuleId : alertData.alertRuleId,
      assetName: alertData.asset,
      assetTypeTemplateName: alertData.assetTypeTemplateTag ,
      ackTimestamp: new Date().getTime(),
      open: open,
      acknowledged : true,
      lineId: Number(alertData.lineId),
      lineRefs: '|'+ alertData.lineId+'|',
      assetRefs: '|'+ alertData.asset+'|',
      alertRuleType: alertData.alertRuleType,
      availableTo: alertData.availableTo,
      childAnomalies: alertData.childAnomalies,
      openTimestamp: alertData.openDatetimeMillis
    };

    let body: string = JSON.stringify(bodyData);

    if (model.alertData$()?.status === AlertStatus.OPEN) {
      this.alertCommentRepository.acknowledgeAlert(body).subscribe((result: any) => {
        if(result) {
          this.closeModal();
          this.emit(new ControllerEvent(AlertControllerEventName.AlertAcknowledged, {}));
        }
      },error => {
        console.log(error);
        this.closeModal();
        this.emit(new ControllerEvent(AlertControllerEventName.AlertAcknowledged, {}));
      });
    }

  }
}
